import { SharpenVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { sharpen } from '@cloudinary/url-gen/actions/adjust'
import { useImageStore } from 'stores/ImageStore'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { SliderField } from './SliderField'

export const SharpenVariant = (props: SharpenVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()

  if (!cloudinary) return null

  return (
    <ImageVariant {...props}>
      <SliderField
        minValue={1}
        maxValue={2000}
        step={1}
        initialValue={variant.qualifier}
        label="Change sharpness"
        onChangeEnd={(value) => {
          const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
          image.effect(sharpen(value))
          imageStore.clearVariants()
          imageStore.createVariant({ image, url: image.toURL(), action: 'sharpen', qualifier: value })
        }}
      />
    </ImageVariant>
  )
}
